export default __webpack_public_path__ + "static/media/github-lightBlue.1f7bdcf3.svg";